export const INPUT_MAX = 15;
export const EDITABLE_INPUT_TYPE = 'number';
export const NUMERIC_TYPES = {
  numeric: 1,
  percentage: 2,
};
